import React from "react";
const StrPage = (props) => {
  const numOfPages = Number(props.num);
  const strPages = numOfPages <= 1 ? `${props.num}page` : `${props.num}pages`;
  return <span>{strPages}</span>;
};

export default StrPage;
